export const reduxKey = '@@EarningsCalculator';
export const actionKey = '@@EarningsCalculator';
